import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var GoogleSlidesSvg = function GoogleSlidesSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C02F",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.833 6.167c.46 0 .834.374.834.839v9.988c0 .463-.37.84-.835.84H6.168a.836.836 0 0 1-.834-.84V7.006c0-.464.37-.84.834-.84zM17 9.5H7v5h10z",
    clipRule: "evenodd"
  }));
};
export var GoogleSlides = function GoogleSlides(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: GoogleSlidesSvg
  }));
};